var map = {
	"./CloudGuard-Service.svg": 925,
	"./Feature-1.svg": 926,
	"./Feature-2.svg": 927,
	"./Feature-3.svg": 928,
	"./Feature-4.svg": 929,
	"./Feature-5.svg": 930,
	"./Feature-6.svg": 931,
	"./Feature-7.svg": 932,
	"./Feature-8.svg": 933,
	"./ManagedService-Service.svg": 934,
	"./VPC-Service.svg": 935,
	"./VPS-Service.svg": 936,
	"./advancedSecurity.svg": 937,
	"./backup.svg": 938,
	"./disaster.svg": 939,
	"./easyBuy.svg": 940,
	"./easyUse.svg": 941,
	"./hunezarat.svg": 922,
	"./liveMigration.svg": 942,
	"./reliability.svg": 943,
	"./service.svg": 944,
	"./startup.svg": 945,
	"./test.svg": 946,
	"./virtualOrganization.svg": 947
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 879;